import QRCode from "qrcode";
import React, { Fragment, useRef } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Menu from "@material-ui/icons/Menu";
import Popper from "@material-ui/core/Popper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { ExpandMoreRounded } from "@material-ui/icons";
// core components
import styles from "assets/jss/material-kit-react/components/headerStyle.js";
import customDropdownStyles from "assets/jss/material-kit-react/components/customDropdownStyle.js";
import { useTranslation } from 'react-i18next';
import SnackbarContent from "components/Snackbar/SnackbarContent";
import config from "assets/config/config.json"
import brandImage from "assets/img/iese-logo-navbar.png";
import { withRouter } from "react-router-dom";
import { Box, Modal } from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer";
import axios from "axios";
import DigitalIdCard from "components/DigitalIdDetail/DigitalIdCard";

const useStyles = makeStyles(styles);
const useCustomDropdownStyles = makeStyles(customDropdownStyles);

function Header(props) {
  const { history } = props;
  const classes = useStyles();
  const customDropdownClasses = useCustomDropdownStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [digitalIdentityOpen, setDigitalIdentityOpen] = React.useState(false);
  // const [digitalIdentityKey, setDigitalIdentityKey] = React.useState("");
  // const canvasRef = useRef();
  const [userData, setUserData] = React.useState({
    name: undefined,
    surname: undefined,
    program: undefined,
    initials: undefined,
    isnotsubscribed: true,
    isExempt: false
  });
  React.useEffect(() => {
    if (props.userData) {
      setUserData({
        ...userData,
        ['name']: props.userData.name,
        ['surname']: props.userData.surname,
        ['program']: props.userData.program,
        ['initials']: (props.userData.name ? props.userData.name.charAt(0).toUpperCase() : "") + (props.userData.surname ? props.userData.surname.charAt(0).toUpperCase() : ""),
        ['isnotsubscribed']: props.userData.isnotsubscribed,
        ['isExempt']: props.userData.isExempt
      });
    }
  }, []);
  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      //window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        //window.removeEventListener("scroll", headerColorChange);
      }
    };
  });
  // React.useEffect(() => {
  //   async function fetchDigitalIdentityData() {
  //     const res = await fetch("/personalinfo/getidentity");
  //     res.text().then(res => {
  //       setDigitalIdentityKey(res);
  //       QRCode.toCanvas(
  //         canvasRef.current,
  //         // QR code doesn't work with an empty string
  //         // so we are using a blank space as a fallback
  //         res || " ", {width: 61, height: 61},
  //         (error) => error && console.error(error)
  //       );
  //     });
  //   }
  //   // fetchData();
  //   if (digitalIdentityOpen) {
  //     fetchDigitalIdentityData();
  //   }
  // }, [digitalIdentityOpen]);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
    }
  };
  const { color, leftLinks, brand, fixed, absolute, sticky, myprofile } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed,
    [classes.sticky]: sticky
  });
  const { t, i18n } = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
    // document.getElementById("spanish").variant = "outlined";
    // document.getElementById("english").variant = "outlined";
  };
  const modalDigitalIdentityBody = (
    <Box bgcolor="white" borderRadius={16} p={4} paddingLeft={{xs: "12px", md: "147px"}} paddingRight={{xs: "12px", md: "147px"}} width={{ xs: "auto", md: "auto" }}
      style={{ maxHeight: '80%', overflow: 'auto' }}>
      <div className="regular-b300 paddingBottom16" style={{ textAlign: "center" }}>{t("Header_DigitalIdentity_Title")}</div>
      <div className="semibold-b400 paddingBottom16" style={{ textAlign: "center" }}>{(userData.name ? userData.name + " " + (userData.surname ? userData.surname : "") : "")}</div>
      <div className="paddingBottom16" style={{ textAlign: "right" }}><Button variant="text" className="semibold-b300" onClick={() => { history.push("/digitalid") }}>{t("Header_DigitalIdentity_MoreInfo")}<Icon className={classes.iconRight}>info</Icon></Button></div>
      <DigitalIdCard userData={props.userData}></DigitalIdCard>
      {/* <div className={classes.digitalIdCardWrapper}>
        <div style={{padding: "24px"}}>
          <div className={classes.flexSpaceBetween} style={{paddingBottom: "10px"}}>
            <div>
              <img style={{ filter: "brightness(0) invert(1)", width: "150px" }}
                src={brandImage}
                className={classes.img}
                alt="brand"
              />
            </div>
            <div>
              <canvas width={61} height={61} style={{ borderRadius: "5.67442px" }} ref={canvasRef} />
            </div>
          </div>
          <div className={classes.flexSpaceBetween + " " + classes.flexAlignItemsCenter}>
            <div>
              <div className="cl-secondary-100 regular-b500">{(userData.name ? userData.name : "")}</div>
              <div className="cl-secondary-100 regular-b500">{(userData.surname ? userData.surname : "")}</div>
            </div>
            <div style={{textAlign:"right"}}>
              <div className="cl-secondary-100 regular-b50" style={{paddingBottom: "7px"}}>{t("Header_DigitalIdentity_AcademicYear")}</div>
              <div className="cl-secondary-100 regular-b500">{(new Date() > new Date('31/08/' + new Date().getFullYear())) ? new Date().getFullYear() + 1 : new Date().getFullYear()}</div>
            </div>
          </div>
        </div>
        <div>
          <svg width="110%" viewBox="0 0 72 13" style={{marginLeft: "-15.69px", marginBottom: "-7px"}}><text x="0" y="13" fontWeight="600" fill="white" opacity="0.3">MEMBER</text></svg>
        </div>
      </div>
      <div className={classes.spacing}></div>
      <div className="paddingBottom16" style={{ textAlign: "center", paddingTop: "34px" }}>
            <a target="_system" href="/personalinfo/getpassbook">
								<img width="165" src="/img/addtowallet.svg" />
            </a>
            <a className='semibold-b300 anchor' style={{ paddingLeft: "24px" }}
              onClick={e => getPassbookByEmail()}>
              {t("Header_DigitalIdentity_PassbookByEmail")}<img loading="lazy"
                  className="gotopageimg"
                  alt={t("Header_DigitalIdentity_PassbookByEmail")} src="/img/rightarrow.svg" /></a>
      </div> */}
      <div className={classes.spacing}></div>
      <GridContainer justify="center">
        <Button className="regular-b200 cl-secondary-900" variant="text" onClick={e => setDigitalIdentityOpen(false)}>
          {t("CloseButton")}
        </Button>
      </GridContainer>
    </Box>
  );
  const digitalIdentityModal = <Modal
    open={digitalIdentityOpen}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
    onClose={e => setDigitalIdentityOpen(false)}
  >
    {modalDigitalIdentityBody}
  </Modal>;
  // const brandComponent = <Button className={classes.title} onClick={() => { window.location.replace(config.ieseAlumni) }}>{brand}</Button>;
  const brandComponent = <Button className={classes.title} onClick={() => { history.push("/") }}>{brand ? brand : <img style={{ filter: "brightness(0) invert(1)" }}
    src={brandImage}
    className={classes.img}
    alt="brand"
  />}</Button>;
  // const digitalIdentityBtn = userData.isnotsubscribed && !userData.isExempt ? "" : <Button className={classes.normalButton} style={{ width: "100%" }} variant="text" id="digitalidentity" onClick={() => { setDigitalIdentityOpen(true) }}><Icon className={classes.icon}>border_clear</Icon>{t("Header_DigitalIdentity")}</Button>;
  const digitalIdentityBtn = userData.isnotsubscribed && !userData.isExempt ? "" : <Button className={classes.normalButton} style={{ width: "100%" }} variant="text" id="digitalidentity" onClick={() => { history.push("/digitalid") }}><Icon className={classes.icon}>border_clear</Icon>{t("Header_DigitalIdentity")}</Button>;
  const myProfileBtn = myprofile ? <Button className={classes.normalButton} style={{ width: "100%" }} variant="text" id="myprofile" onClick={() => { window.location.replace(config.ieseAlumniProfile) }}><Icon className={classes.icon}>person</Icon>{t("Header_MyProfile")}</Button> : "";
  const spanishFlag = <Button className={classes.normalButton} style={{ width: "100%" }} variant="text" id="spanish" onClick={() => { changeLanguage('es') }}><Icon className={classes.icon}>settings</Icon>{t("Header_Spanish")}</Button>;
  const englishFlag = <Button className={classes.normalButton} style={{ width: "100%" }} variant="text" id="english" onClick={() => { changeLanguage('en') }}><Icon className={classes.icon}>settings</Icon>{t("Header_English")}</Button>;
  const logoutButton = <Button className={classes.normalButton} style={{ width: "100%" }} variant="text" id="logout" onClick={() => { window.location.replace(config.logout) }}><Icon className={classes.icon}>login</Icon>{t("Header_LogOut")}</Button>;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const openCloseUserDropdown = event => {
    if (anchorEl && anchorEl.contains(event.target)) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleCloseAway = event => {
    if (anchorEl.contains(event.target)) {
      return;
    }
    setAnchorEl(null);
  };
  const userDropdown = (
    <div>
      <div className="CursorPointer" onClick={openCloseUserDropdown}>
        <span>
          <div>
            <span className="regular-b300 cl-secondary-100">
              {(userData.name ? userData.name + " " + (userData.surname ? userData.surname : "") : "")}
            </span>
          </div>
          {userData.program ?
            <div className="ProgramName">
              <span className="regular-b100 cl-secondary-500">
                {userData.program}</span>
            </div> : ""}
        </span><span className="semibold-b300" data-initials={userData.initials}></span>
        <ExpandMoreRounded fontSize="large" className={classNames({ [customDropdownClasses.caretActive]: Boolean(anchorEl) }, "cl-primary-500")} />
      </div>
    </div>
  );
  let breadcrumnoptions = [];
  if (props.breadcrumb != undefined) {
    props.breadcrumb.forEach(element => {
      if (element.isbutton) {
        breadcrumnoptions.push(<Button key={element.text} variant="text"
          onClick={() => { history.push(element.path) }}
          className={element.selected ? "borderbottomredflat semibold-b300 cl-secondary-100 notshowmobile myheaderbutton" : "borderbottomtransparentflat regular-b300 cl-secondary-100 notshowmobile myheaderbutton"}>{element.text}</Button>);
      } else {
        breadcrumnoptions.push(<span key={element.text} className={element.selected ? "semibold-b300 cl-secondary-100 paddingLeftRight16 notshowmobile" : "regular-b300 cl-secondary-100 paddingLeftRight16 notshowmobile"}>{element.text}</span>);
      }
    });
  }
  return (
    <Fragment>
      <AppBar className={appBarClasses}>
        <Toolbar className={classes.containerflex}>
          {leftLinks !== undefined ? brandComponent : null}
          <div className={classes.flex + " headerBrandWrapper"}>
            {leftLinks !== undefined ? (
              <Hidden smDown implementation="css">
                {leftLinks}
              </Hidden>
            ) : (
              brandComponent
            )}
            {breadcrumnoptions}
          </div>
          <Hidden smDown implementation="css">
            {userDropdown}
          </Hidden>
          <Hidden mdUp>
            {/* <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerToggle}
            >
              <span className="semibold-b300" data-initials={userData.initials}></span>
              <Menu />
            </IconButton> */}
            <div aria-label="open drawer" className="mobileOpenProfileMenu"
              onClick={handleDrawerToggle}
            >
              <span className="semibold-b300" data-initials={userData.initials}></span>
            </div>
          </Hidden>
        </Toolbar>
        <Hidden mdUp implementation="js">
          <Drawer
            variant="temporary"
            anchor={"right"}
            open={mobileOpen}
            classes={{
              paper: classes.drawerPaper
            }}
            onClose={handleDrawerToggle}
          >
            {i18n.language && i18n.language.toLowerCase().startsWith("es") &&
              <div className={classes.appResponsive}>
                {englishFlag}
              </div>}
            {i18n.language && !i18n.language.toLowerCase().startsWith("es") &&
              <div className={classes.appResponsive}>
                {spanishFlag}
              </div>}
            <div className={classes.appResponsive}>
              {digitalIdentityBtn}
            </div>
            <div className={classes.appResponsive}>
              {myProfileBtn}
            </div>
            <div className={classes.appResponsive}>
              {logoutButton}
            </div>
          </Drawer>
        </Hidden>
      </AppBar>
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        transition
        disablePortal
        placement={
          "bottom-end"
        }
        className={classNames({
          [customDropdownClasses.popperClose]: !anchorEl,
          [customDropdownClasses.popperResponsive]: true,
          "UserDropdown": true
        })}
      >
        <ClickAwayListener onClickAway={handleCloseAway}>
          <div>
            {i18n.language && i18n.language.toLowerCase().startsWith("es") && <div>{englishFlag}</div>}
            {i18n.language && !i18n.language.toLowerCase().startsWith("es") && <div>{spanishFlag}</div>}
            <div>{digitalIdentityBtn}</div>
            <div>{myProfileBtn}</div>
            <div>{logoutButton}</div>
          </div>
        </ClickAwayListener>
      </Popper>
      {digitalIdentityModal}
    </Fragment>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.object,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};

export default withRouter(Header);